import { render } from "./ColoredTag.vue?vue&type=template&id=573fbb30&scoped=true"
import script from "./ColoredTag.vue?vue&type=script&lang=js"
export * from "./ColoredTag.vue?vue&type=script&lang=js"

import "./ColoredTag.vue?vue&type=style&index=0&id=573fbb30&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573fbb30"]])

export default __exports__